import { parseAsString, useQueryState } from 'nuqs';

export function useOrderListFilter() {
  const [search, setSearch] = useQueryState('search', parseAsString.withDefault(''));

  return {
    setSearch,
    search,
  };
}
